export class Configuration {
    Id: number;
    ServiceId: number;
    Key: string;
    Value: string;
    CreatedBy: string;
    CreationDate: Date;
    ModifiedBy: string;
    ModifiedDate: string;
    IsDeleted: boolean;
    ConfigurationUnitTypeId: number;
    IsEditable: boolean;
};